// Class-string constants over a `<SecondaryButton>` component: every
// consumer carries its own button props (`onClick`/`disabled`/`type`/
// `aria-*`), so a wrapper would either re-list the HTMLButtonElement
// props surface or rest-spread them (loosening type-safety). Constants
// keep native-button compile-time checks and a single search target.

const SECONDARY_BUTTON_BASE =
  'rounded border border-gray-300 bg-white text-gray-800 hover:bg-gray-50'

export const secondaryButtonBase = SECONDARY_BUTTON_BASE

export const secondaryButtonClass = `${SECONDARY_BUTTON_BASE} px-3 py-1.5 text-sm`

export const secondaryButtonClassFontMedium = `${secondaryButtonClass} font-medium`

export const secondaryButtonClassCompact = `${SECONDARY_BUTTON_BASE} px-3 py-1`

export const secondaryButtonClassCompactSm = `${SECONDARY_BUTTON_BASE} px-3 py-1 text-sm`

export const secondaryButtonClassCompactSmWithDisabled = `${secondaryButtonClassCompactSm} disabled:cursor-not-allowed disabled:opacity-50`

export const secondaryButtonClassIconish = `${SECONDARY_BUTTON_BASE} px-2 py-1 text-sm disabled:cursor-not-allowed disabled:opacity-50`

const DESTRUCTIVE_BUTTON_BASE =
  'rounded bg-red-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-700'

export const destructiveButtonClass = DESTRUCTIVE_BUTTON_BASE

export const destructiveButtonClassWithDisabled = `${DESTRUCTIVE_BUTTON_BASE} disabled:cursor-not-allowed disabled:opacity-50`
